import { useCustomFetch } from '~/shared/lib/useCustomFetch';
import type { ISiteSettingsDTO } from '~/shared/api/client/site-settings/settings.dto';

export const useSiteSettings = async () => {
  const settings = await useCustomFetch<ISiteSettingsDTO>(
    '/main/site-settings/',
    {
      key: 'site_settings',
    },
  );

  const isPBrandActive = computed(() => {
    const start = settings.data.value?.p_brand_backing_start_at;
    const end = settings.data.value?.p_brand_backing_end_at;
    if (!start || !end) return false;

    const now = Date.now();
    return now >= new Date(start).getTime() && now <= new Date(end).getTime();
  });

  return { ...settings, isPBrandActive };
};
